
<fun-skeleton-list *ngIf="!isCharged"></fun-skeleton-list>
<fund-register-full-iframe
        *ngIf="hasUrl" [url]="urlSafe" [isMobileApp]="isMobileApp" 
        (signEvent)="isSigned($event);"
        (signErrorEvent)="signError()"
        (signaturitIssueEvent)="signError()"
        ></fund-register-full-iframe>
